/*********************************************************************************************************************************
 This class has been automatically generated using KLTT-APIRestGenerator project, don't do manual file modifications.
 Mon Oct 22 12:45:25 CEST 2018

 "Licensed to the Apache Software Foundation (ASF) under one or more contributor license agreements;
  and to You under the Apache License, Version 2.0. "
**********************************************************************************************************************************/

import {MyComplexObjectRef} from './my-complex-object-ref.model' ;

/** 
 * This exception will return an array of complex objects reference (two dimensions)
 */
export class ExampleComplexObjectRefException592
{
	/**
	 * @param bodyExceptionMessage with the body exception message
	 */
	constructor(private bodyExceptionMessage: MyComplexObjectRef[][])
    {
		// Empty constructor
    }

	/**
	 * @return the bodyExceptionMessage
	 */
	getBodyExceptionMessage()
	{
		return this.bodyExceptionMessage ;
	}

	/**
	 * @return the object as string
	 */
	toString()
	{
		return JSON.stringify(this, null, 4) ;
	}
} ;
